import { ref } from 'vue';
import { injectable } from 'inversify';

import { SortingOptions } from './SortingOptions';

@injectable()
export class SortingState {

	private selectedOption = ref(SortingOptions.OUR_PICKS);

	public constructor(selected?: SortingOptions) {
		if (selected) {
			this.selectedOption.value = selected;
		}
	}

	public set(option: SortingOptions): void {
		this.selectedOption.value = option;
	}

	public getSelected(): SortingOptions {
		return this.selectedOption.value;
	}

	public isEqual(other: SortingState): boolean {
		return this.selectedOption.value === other.selectedOption.value;
	}

	public isSelected(option: SortingOptions): boolean {
		return this.selectedOption.value === option;
	}

	public replaceWith(other: SortingState): void {
		this.set(other.selectedOption.value);
	}
}
